import { Toaster } from 'components/notification/Toaster';
import usePromiseInstance_authorization from 'dataflow/billingPortal/actions/config';
import { getTotalCountFromHeader, isNumberValid, isObjectNotEmpty } from 'functions';
import { useState, useRef, useEffect } from 'react';
import moment from "moment";
import { useCustomSelector } from 'hooks';


export function useTableData({ selectedMonth }) {
    const data = useRef();
	const totalDataRetrieved = useRef(1);
	const [isDataLoading, setIsDataLoading] = useState();
	const [isFiltering, setIsFiltering] = useState();
	const [totalRecords, setTotalRecords] = useState();
    const request = usePromiseInstance_authorization();
	
	const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    function getData(monthColumnPos, selectedMonth) {
		setIsDataLoading(true);

        request(null, (axios) => {
			axios.get('/Report/GetRevenueReport/' + selectedMonth)
				.then(function (response) {
					// handle success
					setTotalRecords(getTotalCountFromHeader(response?.headers))
					let responseData = response?.data;

					if (responseData) {
						let list = [];
						let cumulativeTotalCharges_exists = false, cumulativeTotalOutlets_exists = false, cumulativeTotalChargesPerOulet_exists = false,
						cumulativeTotalClients_exists = false, cumulativeTotalChargesPerClient_exists = false;
						let cumulativeTotalCharges = 0, cumulativeTotalOutlets = 0, cumulativeTotalChargesPerOulet = 0,
						cumulativeTotalClients = 0, cumulativeTotalChargesPerClient = 0;
						
						for (let i = 0; i < 7; i++) {
							let propertyName = "_" + (i + 1);
							let obj = responseData?.[propertyName];
							if (isObjectNotEmpty(obj)) {
								list.push(obj);

								cumulativeTotalCharges += (obj?.Total_Charges? obj.Total_Charges:0);
								if (obj?.Total_Charges) cumulativeTotalCharges_exists = true;

								cumulativeTotalOutlets += (obj?.Total_Outlet? obj.Total_Outlet:0);
								if (obj?.Total_Charges) cumulativeTotalOutlets_exists = true;

								cumulativeTotalChargesPerOulet += (obj?.Avg_By_Outlet? obj.Avg_By_Outlet:0);
								if (obj?.Total_Charges) cumulativeTotalChargesPerOulet_exists = true;

								cumulativeTotalClients += (obj?.Total_Client? obj.Total_Client:0);
								if (obj?.Total_Charges) cumulativeTotalClients_exists = true;

								cumulativeTotalChargesPerClient += (obj?.Avg_By_Client? obj.Avg_By_Client:0);
								if (obj?.Total_Charges) cumulativeTotalChargesPerClient_exists = true;
							}
							else list.push({})
						}
						

						// Add Total (last row)
						list.push({
							Total_Charges: cumulativeTotalCharges_exists? cumulativeTotalCharges:"",
							Total_Outlet: cumulativeTotalOutlets_exists? cumulativeTotalOutlets:"",
							Avg_By_Outlet: cumulativeTotalChargesPerOulet_exists? cumulativeTotalChargesPerOulet:"",
							Total_Client: cumulativeTotalClients_exists? cumulativeTotalClients:"",
							Avg_By_Client: cumulativeTotalChargesPerClient_exists? cumulativeTotalChargesPerClient:"",
						})

						// Append the properties for each column
						let actualData = data.current;
						if (actualData) {
							data.current = actualData.map((obj, idx) => {
								return {
									...obj,
									["Total_Charges" + monthColumnPos]: list[idx]?.Total_Charges,
									["Total_Outlet" + monthColumnPos]: list[idx]?.Total_Outlet,
									["Avg_By_Outlet" + monthColumnPos]: list[idx]?.Avg_By_Outlet,
									["Total_Client" + monthColumnPos]: list[idx]?.Total_Client,
									["Avg_By_Client" + monthColumnPos]: list[idx]?.Avg_By_Client
								}
							})
						}
						else data.current = list.map((obj, idx) => {
							return {
								["Total_Charges" + monthColumnPos]: obj?.Total_Charges,
								["Total_Outlet" + monthColumnPos]: obj?.Total_Outlet,
								["Avg_By_Outlet" + monthColumnPos]: obj?.Avg_By_Outlet,
								["Total_Client" + monthColumnPos]: obj?.Total_Client,
								["Avg_By_Client" + monthColumnPos]: obj?.Avg_By_Client
							}
						});


						// Add the average column once all months data retrieved
						if (totalDataRetrieved.current === 3 && data.current) {
							function getSum(value1, value2, value3) {
								if (!isNumberValid(value1) && !isNumberValid(value2) && !isNumberValid(value3)) {
									return NaN;
								}
								else {
									let val1 = isNumberValid(value1)? value1:0;
									let val2 = isNumberValid(value2)? value2:0;
									let val3 = isNumberValid(value3)? value3:0;
									return val1 + val2 + val3;
								}
							}
							
							data.current = data.current.map((obj) => {
								let averageCharges = getSum(obj?.Total_Charges0, obj?.Total_Charges1, obj?.Total_Charges2)/3;
								averageCharges = Math.floor(averageCharges * 100) / 100;

								let averageOutlets = getSum(obj?.Total_Outlet0, obj?.Total_Outlet1, obj?.Total_Outlet2)/3;
								averageOutlets = Math.ceil(averageOutlets);

								let averageChargePerOutlet = getSum(obj?.Avg_By_Outlet0, obj?.Avg_By_Outlet1, obj?.Avg_By_Outlet2)/3;
								averageChargePerOutlet = Math.floor(averageChargePerOutlet * 100)/100;

								let averageClients = getSum(obj?.Total_Client0, obj?.Total_Client1, obj?.Total_Client2)/3;
								averageClients = Math.ceil(averageClients);

								let averageChargePerClient = getSum(obj?.Avg_By_Client0, obj?.Avg_By_Client1, obj?.Avg_By_Client2)/3;
								averageChargePerClient = Math.floor(averageChargePerClient * 100)/100;
								
								return {
									...obj,
									["averageCharges"]: averageCharges,
									["averageOutlets"]: averageOutlets,
									["averageChargePerOutlet"]: averageChargePerOutlet,
									["averageClients"]: averageClients,
									["averageChargePerClient"]: averageChargePerClient
								}
							})
							totalDataRetrieved.current = 1;
							setIsDataLoading(false);
							setIsFiltering(false);
						}
						else {
							totalDataRetrieved.current = totalDataRetrieved.current + 1;
						}
					}
				})
				.catch(function (response) {
					setIsDataLoading(false);
					setIsFiltering(false);

					// handle error
					if (response?.data?.exceptionMessage) {
						Toaster({
							type: "error",
							msg: response?.data?.exceptionMessage
						})
					}
				})
				.finally(function () {
					// always executed
				});
		})
    }
	function getAll3Months() {
		if (userPermissions?.Internal_RevenueReport_View) {
			getData(0, selectedMonth.current);
			let currrentMonthPos = moment(selectedMonth.current).month();
			getData(1, moment(selectedMonth.current).month(currrentMonthPos - 1).format("YYYY-MM-DD"));
			getData(2, moment(selectedMonth.current).month(currrentMonthPos - 2).format("YYYY-MM-DD"));
		}
		else {
			Toaster({
				type: "error",
				msg: "'Revenue Report: View' permission required"
			})
		}
	}

    return {
        getData: getAll3Months,
        data: data.current, totalRecords,
		isDataLoading,
		isFiltering, setIsFiltering
    }
}